module.exports = __webpack_public_path__ + "static/media/no-image.6535fcf8.jpg";